import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Loader from "../child/Loder";
import SuccessAlert from "../child/Alert/SuccessAlert";
import DengerAlert from "../child/Alert/DengerAlert";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserById, updateUserById } from "../../redux/user/userThunks";
import { clearUserData } from "../../redux/user/userSlice";

const EditUserPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { userData, loading, error } = useSelector((state) => state.user);

  const [formData, setFormData] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [errors, setErrors] = useState({});

  // Fetch user data on mount
  useEffect(() => {
    dispatch(fetchUserById({ id, navigate }));
    return () => dispatch(clearUserData());
  }, [dispatch, id, navigate]);

  // Sync redux userData to local formData
  useEffect(() => {
    if (userData) setFormData(userData);
  }, [userData]);

  const validateName = (name) => {
    const trimmed = name.trim();
    const regex = /^[a-zA-Z\s'-]{2,50}$/; // letters, spaces, apostrophes, hyphens

    if (!trimmed) return "Name is required";
    if (!regex.test(trimmed))
      return "Name can only contain letters, spaces, hyphens, and apostrophes";
    return "";
  };
  const validateDOB = (dob) => {
    if (!dob) return "Date of Birth is required";

    const date = new Date(dob);
    const age = Math.floor(
      (new Date() - date) / (365.25 * 24 * 60 * 60 * 1000)
    );

    if (age < 14) return "Age must be at least 14"; // your earlier rule
    if (age > 120) return "Invalid age";

    return "";
  };

  // Handle form change
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (!formData) return;

    if (name.startsWith("location.")) {
      const locField = name.split(".")[1];
      setFormData((prev) => ({
        ...prev,
        location: {
          ...prev.location,
          [locField]: value,
        },
      }));

      if (name === "fullName") {
        const error = validateName(value);
        setErrors((prev) => ({ ...prev, fullName: error }));
      }

      if (name === "dateOfBirth") {
        setErrors((prev) => ({ ...prev, dateOfBirth: validateDOB(value) }));
      }
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: type === "checkbox" ? checked : value,
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData) return;

    // Ensure location object exists
    const updatedData = {
      ...formData,
      location: {
        ...formData.location, // keep existing type/coordinates
        address: formData.location?.address || "",
      },
    };

    const resultAction = await dispatch(
      updateUserById({ id, data: updatedData, navigate })
    );

    if (updateUserById.fulfilled.match(resultAction)) {
      setSuccessMessage("User updated successfully");
      setTimeout(() => {
        setSuccessMessage("");
        navigate("/user");
      }, 500);
    }
  };

  if (loading || !formData) return <Loader />;

  return (
    <div className="row gy-4">
      <div className="col-lg-12">
        <div className="card">
          <div className="card-body">
            {successMessage && <SuccessAlert message={successMessage} />}
            {error && <DengerAlert message={error} />}

            <form onSubmit={handleSubmit} className="row gy-3">
              <div className="col-md-6">
                <label className="form-label">Name</label>
                <input
                  type="text"
                  name="fullName"
                  className="form-control"
                  placeholder="Enter Name"
                  maxLength={50} 
                  value={formData.fullName || ""}
                  onChange={handleChange}
                  onInput={(e) => {
                    e.target.value = e.target.value
                      .replace(/\s{2,}/g, " ") 
                      .trimStart(); 
                  }}
                />
                {errors.fullName && (
                  <div className="text-danger mt-1">{errors.fullName}</div>
                )}
              </div>

              <div className="col-md-6">
                <label className="form-label">Email</label>
                <input
                  type="email"
                  name="email"
                  className="form-control"
                  value={formData.email || ""}
                  // onChange={handleChange}
                  disabled
                />
              </div>

              <div className="col-md-4">
                <label className="form-label">Date of Birth</label>
                <input
                  type="date"
                  name="dateOfBirth"
                  className="form-control"
                  value={
                    formData.dateOfBirth
                      ? formData.dateOfBirth.split("T")[0]
                      : ""
                  }
                  onChange={handleChange}
                />
                {errors.dateOfBirth && (
                  <div className="text-danger mt-1">{errors.dateOfBirth}</div>
                )}
              </div>
              <div className="col-md-4">
                <label className="form-label">gender</label>
                <select
                  name="gender"
                  className="form-select"
                  value={formData.gender}
                  onChange={handleChange}
                >
                  <option value="">Select Gender</option>
                  <option value="men">Men</option>
                  <option value="women">Women</option>
                  <option value="beyond_binary">Beyond Binary</option>
                </select>
              </div>

              {/* <div className="col-md-3">
                <label className="form-label">Email Verified</label>
                <select
                  name="isEmailVerified"
                  className="form-select"
                  value={formData.isEmailVerified ? "true" : "false"}
                  onChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      isEmailVerified: e.target.value === "true",
                    }))
                  }
                >
                  <option value="true">Yes</option>
                  <option value="false">No</option>
                </select>
              </div> */}

              <div className="col-md-4">
                <label className="form-label">Login Type</label>
                <input
                  type="text"
                  name="loginType"
                  className="form-control"
                  value={formData.loginType || ""}
                  disabled
                />
              </div>

              <div className="col-md-12">
                <label className="form-label">Address</label>
                <input
                  type="text"
                  name="address"
                  className="form-control"
                  placeholder="Enter Address"
                  maxLength={100}
                  value={formData.location?.address || ""}
                  onChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      location: {
                        ...prev.location, // keep type & coordinates
                        address: e.target.value,
                      },
                    }))
                  }
                  onInput={(e) => {
                    e.target.value = e.target.value
                      .replace(/\s{2,}/g, " ")
                      .trimStart();
                  }}
                />
              </div>

              <div className="col-12 text-end">
                <button className="btn btn-primary" type="submit">
                  Save Changes
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditUserPage;
